import { render, staticRenderFns } from "./btnReadIDCard.vue?vue&type=template&id=d314862e"
import script from "./btnReadIDCard.vue?vue&type=script&lang=js"
export * from "./btnReadIDCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports